import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    Alert,
    AngebotsListenZuordnungDTO,
    AngebotVersionsListenAnfrageDTO,
    AngebotsVersionsListe,
    AngebotsListeZuordnungAntwortDto,
    ZuordnungZeile,
    ZuordnungenAnfrageDto,
} from 'src/app/shared/model';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { AngebotsListenService } from './interfaces/angebots-listen.service';
import { IndustriepartnerService } from './interfaces/industriepartner.service';
import { SERVICE_URL } from '../../../environments/tokens';
import { environment } from 'src/environments/environment';

@Injectable()
export class AngebotsListenHttpService implements AngebotsListenService {
    private serviceUrl: string;
    constructor(
        private http: HttpClient,
        private industriepartnerService: IndustriepartnerService,
        @Inject(SERVICE_URL) baseUrl: string
    ) {
        this.serviceUrl = baseUrl + 'angebotliste';
    }

    public test(): Observable<Alert> {
        return this.http.get<Alert>(this.serviceUrl + 'test');
    }

    public einlesen(
        file: File,
        angebotsListenId: string,
        listenName: string,
        gueltigVon: string,
        gueltigBis: string
    ): Observable<any> {
        const formData = new FormData();
        const fileType = file.name.split('.').pop();
        formData.append('file', file);
        formData.append('fileType', fileType);
        formData.append('listenName', listenName);
        formData.append('mindestBestellMenge', String(0));
        formData.append('mindestUmsatz', String(0));
        formData.append(
            'anbieterNr',
            this.industriepartnerService.getAnbieterNr().toString()
        );
        if (angebotsListenId !== null) {
            formData.append('angebotsListenId', angebotsListenId);
        }
        if (gueltigVon !== null) {
            formData.append(
                'gueltigVon',
                moment(gueltigVon).format('YYYY-MM-DD')
            );
        }
        if (gueltigBis !== null) {
            formData.append(
                'gueltigBis',
                moment(gueltigBis).format('YYYY-MM-DD')
            );
        }
        return this.http.post<any>(this.serviceUrl, formData);
    }

    public getAngebotsListenVonIndustriepartner(): Observable<any> {
        return this.http.get<any>(
            `${
                this.serviceUrl
            }/industriepartner/${this.industriepartnerService.getAnbieterNr()}`
        );
    }

    public getVersionsnummerVonAngebotsliste(id: string): Observable<number> {
        return this.http.get<any>(`${this.serviceUrl}/version/${id}`);
    }

    public getAllAngebotsVersionslisten(anbieterNr) {
        return this.http.get(this.serviceUrl+'/'+anbieterNr+'/angebotversionslisten');
    }

    public zuordnen(
        angebotsListenId: string,
        apothekenIds: string[],
        gruppenIds: string[],
        kooperationIds: string[],
        exclusiveListe: boolean
    ) {
        const dto: AngebotsListenZuordnungDTO = {
            angebotsListenId,
            apothekenIds,
            gruppenIds,
            kooperationIds,
            exclusiveListe
        };
        return this.http.post(`${this.serviceUrl}/zuordnung/`, dto, {
            params: {
                anbieterNr: this.industriepartnerService
                    .getAnbieterNr()
                    .toString(),
            },
        });
    }

    public zuordnenDefaultListe(angebotsListenId: string) {
        const anbieterNr = this.industriepartnerService.getAnbieterNr();
        return this.http.post(
            `${this.serviceUrl}/zuordnung/default_list/${angebotsListenId}/${anbieterNr}`,
            {}
        );
    }

    public getAngebotVersionsListenInZeitraum(
        von: Date,
        bis: Date
    ): Observable<AngebotsVersionsListe[]> {
        const anfrage: AngebotVersionsListenAnfrageDTO = {
            von,
            bis,
            anbieterNummer: this.industriepartnerService.getAnbieterNr(),
        };
        return this.http.post<AngebotsVersionsListe[]>(
            `${this.serviceUrl}/angebotversionslisten/`,
            anfrage
        );
    }

    getZuordnungenForAngebotListe(
        listenId: string
    ): Observable<AngebotsListeZuordnungAntwortDto> {
        return this.http.get<AngebotsListeZuordnungAntwortDto>(
            `${this.serviceUrl}/zuordnungen/${listenId}`
        );
    }

    getZuordnungenZuAngebotVersionsListenIds(
        angebotVersionsListenIds: string[]
    ): Observable<ZuordnungZeile[]> {
        const anfrage: ZuordnungenAnfrageDto = {
            angebotVersionsListenIds,
        };
        return this.http.post<ZuordnungZeile[]>(
            `${this.serviceUrl}/zuordnungen/`,
            anfrage
        );
    }

    deleteListe(avlId) {
        return this.http.delete(this.serviceUrl+'/angebotsversionsliste/'+avlId);
    }

    getAngebotsVersionsListe(avlId) {
        return this.http.get(this.serviceUrl+'/angebotsversionslisten/'+avlId);
    }

    putAngebotsVersionsListeBase(avlId, data) {
        return this.http.put(this.serviceUrl+'/angebotsversionslisten/'+avlId+'/base', data);
    }

    putAngebotsVersionsListePos(element) {
        return this.http.put(this.serviceUrl+'/angebotsversionslisten/positions', element);
    }
}
